import { Box, Skeleton, Card, CardContent, Stack } from '@mui/material';
import ContactOverviewSkeleton from './contact-overview';

const ContactSkeleton = () => {
    return (
        <Box sx={{ p: 2 }}>
            <Card>
                <CardContent>
                    <Stack
                        direction="row"
                        spacing={2}
                        alignItems="center"
                        sx={{ mb: 2 }}
                    >
                        {/* Avatar Skeleton */}
                        <Skeleton variant="circular" width={64} height={64} />
                        <Box>
                            {/* Name Skeleton */}
                            <Skeleton variant="text" width={120} height={32} />
                            {/* Tabs Skeleton */}
                            <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
                                <Skeleton
                                    variant="text"
                                    width={80}
                                    height={24}
                                />
                                <Skeleton
                                    variant="text"
                                    width={80}
                                    height={24}
                                />
                                <Skeleton
                                    variant="text"
                                    width={80}
                                    height={24}
                                />
                                <Skeleton
                                    variant="text"
                                    width={80}
                                    height={24}
                                />
                            </Stack>
                        </Box>
                    </Stack>

                    <ContactOverviewSkeleton />
                </CardContent>
            </Card>
        </Box>
    );
};

export default ContactSkeleton;
